export const GET_ROOMS = "room/list",
  GET_PROVIDERS = "provider/list",
  GET_PROCEDURES = "procedure/list",
  GET_SCHEDULES = "schedule/list/all",
  GET_END_OF_DAY_CASES = "procedure/end-of-day-cases",
  MANAGE_SCHEDULE = "schedule/manage",
  GET_UNSCHEDULED_PROCEDURES = "schedule/list/unassigned",
  GET_FACILITIES = "facilities/list",
  GET_SURGEONS = "surgeon/list",
  ADD_CASE = "procedure/create",
  GET_CASE = "procedure/get-case",
  UPDATE_CASE = "procedure/edit-case",
  ADD_SURGEON_BLOCK_TIMINGS = "surgeon/block-timings",
  GET_SURGEON_BLOCK_TIMINGS = "surgeon/block-timings-form-data",
  GET_SURGEON_BLOCK_TIMINGS_BOARD = "surgeon/all-surgeon-schedules",
  GET_SITES = "room/list/site",
  GET_POSITION_TYPES = "shifts/list/positions",
  GET_SITE_ROOMS = "room/list/room-no",
  GET_FACILITY_DETAIL = "procedure/get-case-count",
  GET_FACILITIES_SETTINGS = "facilities/settings",
  GET_GO_HOME_LIST = "provider/get-go-home-list",
  EDIT_GOT_HOME_LIST = "provider/edit-go-home-list",
  GET_PROVIDER_MESSAGES = "provider/providers-messages-list",
  GET_SHIFTS = "shifts",
  UPDATE_SHIFT = "shifts/update-shift",
  GET_RELATED_GAS_SHIFTS = "shifts/related-gas-shifts",
  REVERT_MULTIPLE_SHIFT_PROVIDERS = "shifts/revert-temp-provider",
  UNASSIGN_PROVIDER_FROM_SHIFT = "shifts/unassign-provider",
  UNASSIGN_SHARE_PROVIDER = "shifts/unassign-share-shift",
  SELF_ASSIGN_PROVIDER_TO_SHIFT = "shifts/assign-self",
  ASSIGN_PROVIDER_TO_SHIFT = "shifts/assign-provider",
  GET_PROVIDER_BY_FACILITY = "provider/all",
  GET_SHIFT_CHANGE_REQUEST_COUNT = "shifts/get-shift-change-request",
  UPDATE_PROVIDER_REQUEST_COUNT = "provider/providers-change-request",
  // GET_ASSIGNED_PROVIDERS = (facilityId, date) =>
  //   `schedule/assigned/list?facilityId=${facilityId}&date=${date}`,
  GET_ASSIGNED_PROVIDERS = (facilityId) =>
    `schedule/assigned/list?facilityId=${facilityId}`,
  GET_POSITIONS_BY_FACILITY_ID = (facilityId) =>
    `shifts/get-position-strings?facilityId=${facilityId}`,
  CREATE_MULTIPLE_SHIFTS = "shifts/create-shifts",
  GET_MAX_POSITION_SEQUENCE = "shifts/max/position-sequence",
  CREATE_EXTRA_SHIFTS = "shifts/create-extra-shifts",
  SWAP_OR_TRANSFER_PROVIDER = "shifts/swap-or-transfer-providers",
  DELETE_MULTIPLE_SHIFTS = "shifts/delete-multiple-shifts",
  DELETE_HOSPITAL_SHIFT = "shifts/hospital-shift-delete",
  GET_PROVIDER_SCHEDULES = "provider/get-off-providers",
  GET_PROVIDERS_FOR_SWAP_OR_TRANSFER =
    "provider/get-providers-for-swap-or-transfer",
  SHARE_PROVIDER = "shifts/share-shift-providers",
  GET_BOARD_RUNNERS = "schedule/get-board-runner",
  GET_BOARD_ASSIGNMENTS = "schedule/get-board-assignments",
  ASSIGN_BOARD_RUNNER = "schedule/assign-board-runner",
  UNASSIGN_BOARD_RUNNER = "schedule/unassign-board-runner",
  ASSIGN_BOARD_ASSIGNMENT = "schedule/assign-board-assignment",
  UNASSIGN_BOARD_ASSIGNMENT = "schedule/unassign-board-assignment",
  GET_PROVIDER_SCHEDULIGN_RULES = "schedule/scheduling/rules",
  GET_NOTIFICATIONS = "provider/get-notifications",
  SEND_PROVIDER_NOTIFICATION = "provider/send-notifications",
  SEND_MULTIPLE_NOTIFICATIONS = "provider/send-multiple-notifications",
  MAANGE_SWAP_OR_TRANSFER = "shifts/manage-swap-or-transfer",
  MANAGE_PROVIDER_SHIFT_ASSIGNMENT = "shifts/assign-requested",
  MANAGE_FORECASTER_SHIFT_ASSIGNMENT =
    "shifts/manage-forecaster-shift-assignment",
  GET_CONFLICTING_SHIFTS = "shifts/get-conflicting-shifts",
  GET_PROVIDER_COUNT = "procedure/forecasted",
  GET_FORECAST_DATA_BY_FACILITY = (
    facilityId,
    selectedDate,
    selectedShiftType,
  ) =>
    `shifts/forecasted-data?facilityId=${facilityId}&date=${selectedDate}&type=${selectedShiftType}`,
  UPDATE_FACILITY_PEEL_OFF = "facilities/peel-off",
  GET_FORECAST_COUNTS = (facilityId, selectedDate) =>
    `shifts/forecasted-counts?facilityId=${facilityId}&date=${selectedDate}`,
  NOTIFY_CHIEFS = "shifts/notify-create-shift",
  GET_SHIFTS_CONFLICTS = "shifts/check-conflicting-shifts",
  FORECASTED_SHIFTS_REQUEST = "shifts/forecasted-shifts-request",
  PUBLISH_OPEN_SHIFTS = "shifts/publish-open-shifts",
  // auth
  TOUR_COMPLETE = "auth/tour-complete",
  REIGSTER = "auth/register",
  LOGIN = "auth/login",
  ME = "auth/me",
  GENERATE_HANDOFF_CODE = "auth/generate-handoff-code",
  EXCHANGE_HANDOFF_CODE = "auth/exchange-handoff-code",
  // user
  UPDATE_PROFILE = "user/update",
  FILE_UPLOAD= "action/upload",
  MARK_NOTIFICATIONS_READ = "provider/mark-notifications-read";
